import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
})
export class LeaderboardInitialsPipe implements PipeTransform {
  transform(fullname: string, lastnameOnly: boolean = false): string {
    if (!fullname) return '';

    const names = fullname.split(' ');

    if (lastnameOnly && names.length > 0) {
      names[1] = names[1].slice(0, 1);
      return names.splice(0, 2).join(' ');
    }

    let initials = '';

    if (names[0]) initials += names[0][0].toUpperCase();
    if (names[1]) initials += names[names.length - 1][0].toUpperCase();

    return initials;
  }
}
